// Code JavaScript pour calculer les loadingMeters d'un shippingOrder
// en utilisant une approche gloutonne d'empilement avec logique métier (surface au sol / 2.4)



const MAX_HEIGHT = 260; // hauteur max en cm
const MAX_STACK_LEVELS = 4; // nombre maximum de palettes empilées
const DIM_TOLERANCE = 0.1; // tolérance en cm


function canStack(base, candidate, stackHeight, stackLevels) {
    const fitsDimensions = (
        (candidate.huLength <= base.huLength + DIM_TOLERANCE && candidate.huWidth <= base.huWidth + DIM_TOLERANCE) ||
        (candidate.huLength <= base.huWidth + DIM_TOLERANCE && candidate.huWidth <= base.huLength + DIM_TOLERANCE)
    );
    //   const respectsWeight = base.huWeight >= candidate.huWeight;
    const respectsWeight = candidate.huWeight <= base.huWeight;
    return (
        base.isStackable &&
        fitsDimensions &&
        respectsWeight &&
        (stackHeight + candidate.huHeight <= MAX_HEIGHT) &&
        (stackLevels < MAX_STACK_LEVELS)
    );
}

function groupIntoStacks(units) {
    let remaining = [...units];
    let stacks = [];

    while (remaining.length > 0) {
        const current = remaining.shift();
        let placed = false;

        for (let stack of stacks) {
            const base = stack[0];
            let stackHeight = stack.reduce((sum, hu) => sum + hu.huHeight, 0);
            let stackLevels = stack.length;

            if (canStack(base, current, stackHeight, stackLevels)) {
                stack.push(current);
                placed = true;
                break;
            }
        }

        if (!placed) {
            stacks.push([current]);
        }
    }

    return stacks;
}

function computeLoadingMetersFromStacks(stacks) {
    let totalSurface = 0;
    for (const stack of stacks) {
        const base = stack[0];
        const surfaceM2 = (base.huLength * base.huWidth) / 10000;
        totalSurface += surfaceM2;
    }
    return totalSurface / 2.4;
}

function computeLoadingMeters(handlingUnits) {
    const sortedUnits = handlingUnits.sort((a, b) => {
        // 1. Mettre en priorité les empilables
        if (a.isStackable !== b.isStackable) return b.isStackable - a.isStackable;

        // 2. Trier par surface
        const areaA = a.huLength * a.huWidth;
        const areaB = b.huLength * b.huWidth;
        if (areaA !== areaB) return areaB - areaA;

        // 3. Puis par poids
        return b.huWeight - a.huWeight;
    });

    const stacks = groupIntoStacks(sortedUnits);
    const totalMeters = computeLoadingMetersFromStacks(stacks);
    //   console.log("Total loading meters:", totalMeters);
    return totalMeters.toFixed(2); // Retourne la longueur totale en mètres
}


// console.log("Loading meters:", computeLoadingMeters(debugShippingOrder.handlingUnits));

export { computeLoadingMeters }